// extracted by mini-css-extract-plugin
export var infoRow = "_ur-2";
export var labelContainer = "_ur-0";
export var rightInfo = "_ur-1";